export default __webpack_public_path__ + "static/media/aws-api-gateway.1774d671.svg";